import React from "react";
import { Props } from "./types";

function DownloadIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 11.25 13.5">
      <path
        d="M18,9.264H14.787V4.5H9.963V9.264H6.75l5.625,5.558ZM6.75,16.411V18H18V16.411Z"
        transform="translate(-6.75 -4.5)"
      />
    </svg>
  );
}

export { DownloadIcon };
